export default __webpack_public_path__ + "static/media/IconDesc_Wreath.256.cdfc1fa1.png";